// {
//   document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll(".banner_slider").forEach((slider) => {
//       const wrapper = slider.querySelector(".swiper-wrapper");
//       const originalSlides = slider.querySelectorAll(".swiper-slide");
//       const clones = parseInt(slider.dataset.cloneMultiplier, 10) || 1;

//       for (let i = 0; i < clones; i++) {
//         originalSlides.forEach((s) => wrapper.appendChild(s.cloneNode(true)));
//       }
//       const swiper = new Swiper(slider, {
//         loop: true,
//         slidesPerView: "auto",
//         grabCursor: true,
//         direction: "horizontal",
//         autoplay: {
//           delay: 0,
//           disableOnInteraction: false,
//         },
//         speed: 5000,
//         pagination: {
//           el: slider.querySelector(".swiper-pagination"),
//           clickable: true,
//         },
//         breakpoints: {
//           1200: { spaceBetween: 30 },
//           1025: { spaceBetween: 20 },
//           769: { spaceBetween: 20 },
//           576: { spaceBetween: 15 },
//           300: { spaceBetween: 10 },
//         },
//       });
//     });
//   });
// }
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".Products__lists");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.2,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            769: {
              slidesPerView: 2.6,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".Products__list_2count ");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 1.6,
              spaceBetween: 15,
            },
            769: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".Testi_slider");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          loop: true,
          speed: 1000,
          autoplay: {
            delay: 1000,
            disableOnInteraction: false,
          },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.2,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            769: {
              slidesPerView: 2.6,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 3.2,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".TestiProructs");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          loop: true,
          speed: 1000,
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            769: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            1025: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            1200: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
